var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhoneCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_78_4558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8973 13.9273L14.9086 15.9161C13.5378 17.2868 11.3075 17.2868 9.93673 15.9161L2.18065 8.15999C0.809917 6.78926 0.809917 4.55889 2.18065 3.18815L4.16939 1.19941C4.44399 0.924817 4.88917 0.924817 5.16376 1.19941L8.14687 4.18252C8.42146 4.45711 8.42146 4.90229 8.14687 5.17689L7.1525 6.17126C6.87835 6.4454 6.87835 6.89148 7.1525 7.16563L10.9311 10.9442C11.2052 11.2184 11.6513 11.2184 11.9255 10.9442L12.9198 9.94986C13.1944 9.67526 13.6396 9.67526 13.9142 9.94986L16.8973 12.933C17.1719 13.2076 17.1719 13.6527 16.8973 13.9273ZM3.17502 4.18252C2.35258 5.00496 2.35258 6.34318 3.17502 7.16563L10.9311 14.9217C11.7535 15.7441 13.0918 15.7441 13.9142 14.9217L15.4058 13.4301L13.417 11.4414L12.9198 11.9386C12.0974 12.761 10.7592 12.761 9.93673 11.9386L6.15813 8.15999C5.33569 7.33755 5.33569 5.99933 6.15813 5.17689L6.65531 4.6797L4.66658 2.69097L3.17502 4.18252Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_78_4558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneCall);
export default __webpack_public_path__ + "static/media/phone-call.92e82cd2e4bc8ecd8fb7cadb05a62539.svg";
export { ForwardRef as ReactComponent };